<template>
    <div id="app" ref="scrollEle">
        <!-- 加载遮罩 -->
        <Loading v-if="isLoading" />
        <div class="top-banner section" v-for="(item, index) in list" :key="index">
            <div class="posi-img">
                <div class="music-box" v-if="item.musicPlay">
                    <div class="title-words">
                        <p>在开始之前，先选择一下陪伴你的背景音乐吧</p>
                        <p>Before we begin, select your preferred background music</p>
                    </div>
                    <ul class="music-play-main" id="musicPlayBox">
                        <li class="music-play-item" v-for="(item, index) in musicData" :key="item.name">
                            <div class="music-img-box">
                                <img v-lazy="item.img" alt="" class="music-playbill" :id="`musicPlay${index}`" />
                            </div>
                            <p class="song-name">{{ item.name }}</p>
                            <p class="discription">{{ item.discri }}</p>
                            <MusicAudio
                                v-bind:musicIndex="index"
                                v-bind:audio="item.music"
                                @banHandler="addBanClass"
                                @MarkBackgroundMusic="markBackgroundMusicHandler"
                                @banAllMicroPhone="banAllMicroPhoneHandler"
                                @clearnBackgroundMusic="clearnBackgroundMusicHandler"
                                @markMusicIndex="markMusicIndexHandler"
                            ></MusicAudio>
                            <button>Select</button>
                        </li>
                    </ul>
                    <div class="title-words left">
                        <p>下滑开始观赏线上展览</p>
                        <p>Scroll down to begin your walkthrough</p>
                    </div>
                </div>
                <img class="wall-photo" v-lazy="`http://www.artgogo.com/online-exhibition/amicitia/original-img/${item.backgroundImg}`" />
                <!-- 气泡卡片 小地图位置 -->
                <div class="backTo" v-on:click="back" v-if="item.goback">
                    <img src="http://www.artgogo.com/online-exhibition/img/fanhui.png"/>
                </div>
                <p class="title-intro" v-if="item.title" v-html="item.title"></p>
                <Mappopover v-bind:mapShow="item.mapVisible" v-bind:microphone="item.microphone" v-bind:mapIcon="item.mapIcon" v-bind:idx="index"> </Mappopover>
                <div v-show="item.microphone" :class="[item.microphone && item.mapIcon ? 'ml' : '', 'microphone', item.ban ? 'ban' : '']">
                    <svg class="icon icon-microphone" aria-hidden="true">
                        <use xlink:href="#icon-microphone"></use>
                    </svg>
                    <!-- 单组轮播 播放语音 -->
                    <Audio
                        v-if="item.audioCont"
                        v-bind:anchorIndex="index"
                        v-bind:audioCont="item.audioCont"
                        v-bind:lyric="item.lyric"
                        v-bind:switchBanner="item.switchBanner"
                        @banHandler="addBanClass"
                        @changeMicrophone="changeMicrophoneState"
                        @resetMicrophone="resetMicrophoneState"
                        @playBackgroundMusic="playBackgroundMusicHandler"
                        @stopBackgroundMusic="stopBackgroundMusicHandler"
                    >
                    </Audio>
                </div>
                <!-- 放大镜 -->
                <Search
                    @changeMask="toshow"
                    v-if="item.carousel || item.single"
                    v-bind:searchPosMess="item.className || item.classNameOne"
                    v-bind:anchorIndex="index"
                    v-bind:hasHandler="item.hasHandler"
                    v-bind:showFallMess="item.single"
                    v-bind:hasAudio="item.hasAudio"
                    @playBackgroundMusic="playBackgroundMusicHandler"
                >
                </Search>
                <Search
                    @changeMask="toshow"
                    v-if="item.carouselOne || item.baique"
                    v-bind:anchorIndex="index"
                    v-bind:searchPosMess="item.classNameOne"
                    v-bind:showFallMess="item.baique"
                    v-bind:hasHandler="item.hasHandler"
                >
                </Search>

                <Search
                    @changeMask="toshow"
                    v-if="item.carouselTwo || item.yangdifei"
                    v-bind:anchorIndex="index"
                    v-bind:searchPosMess="item.classNameTwo"
                    v-bind:hasHandler="item.hasHandler"
                    v-bind:showFallMess="item.yangdifei"
                    v-bind:hasAudio="item.hasAudio"
                    @playBackgroundMusic="playBackgroundMusicHandler"
                >
                </Search>

                <!-- 图片集锦区域      -->
                <Artworkalbum v-if="item.artworkAlbum"></Artworkalbum>
            </div>

            <!--  单组轮播部分 -->
            <div v-if="item.carousel" style="width:100%">
                <a-button type="primary" :class="item.className" @click="showDrawer(index)"> <a-icon type="plus" /> </a-button>
                <a-drawer :width="width" :visible="item.visible" :body-style="{ background: 'rgba(0,0,0,0.8)' }" @close="onClose(index)">
                    <div class="slide-box">
                        <img class="back-img" v-lazy="`http://www.artgogo.com/online-exhibition/amicitia/original-img/${item.backgroundImg}`"  alt="">
                        <Carousel v-bind:artwork="item.carousel"></Carousel>
                    </div>
                </a-drawer>
            </div>

            <!--  双组轮播部分 -->
            <div v-if="item.carouselOne" style="width:100%">
                <a-button type="primary" :class="item.classNameOne" @click="showDrawerOne(index)"> <a-icon type="plus" /> </a-button>
                <a-drawer :width="width" :visible="item.visibleOne" :body-style="{ background: 'rgba(0,0,0,0.8)' }" @close="onClose(index)">
                    <div class="slide-box">
                        <img class="back-img" v-lazy="`http://www.artgogo.com/online-exhibition/amicitia/original-img/${item.backgroundImg}`"  alt="">
                        <Carousel v-bind:artwork="item.carouselOne"></Carousel>
                        <div v-show="item.audioCont1" :class="['microphone', item.ban ? 'ban' : '']">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#icon-microphone"></use>
                            </svg>
                            <!-- 双组轮播 播放语音 -->
                            <Audio
                                v-if="item.audioCont1"
                                v-bind:anchorIndex="index"
                                v-bind:audioCont="item.audioCont1"
                                v-bind:lyric="item.lyric1"
                                v-bind:id="item.classNameOne"
                                v-bind:switchBanner="item.switchBanner"
                                @banHandler="addBanClass"
                                @changeMicrophone="changeMicrophoneState"
                                @resetMicrophone="resetMicrophoneState"
                                @playBackgroundMusic="playBackgroundMusicHandler"
                                @stopBackgroundMusic="stopBackgroundMusicHandler"
                            >
                            </Audio>
                        </div>
                    </div>
                </a-drawer>
            </div>

            <div v-if="item.carouselTwo" style="width:100%">
                <a-button type="primary" :class="item.classNameTwo" @click="showDrawerTwo(index)"> <a-icon type="plus" /> </a-button>
                <a-drawer :width="width" :visible="item.visibleTwo" :body-style="{ background: 'rgba(0,0,0,0.8)' }" @close="onClose(index)">
                    <div class="slide-box">
                        <img class="back-img" v-lazy="`http://www.artgogo.com/online-exhibition/amicitia/original-img/${item.backgroundImg}`"  alt="">
                        <Carousel v-bind:artwork="item.carouselTwo"></Carousel>
                        <div v-show="item.audioCont2" :class="['microphone', item.ban2 ? 'ban2' : '']">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#icon-microphone"></use>
                            </svg>
                            <!-- 双组轮播 播放语音 -->
                            <Audio
                                v-if="item.audioCont2"
                                v-bind:anchorIndex="index"
                                v-bind:audioCont="item.audioCont2"
                                v-bind:ban2Class="true"
                                v-bind:lyric="item.lyric2"
                                v-bind:id="item.classNameTwo"
                                v-bind:switchBanner="item.switchBanner"
                                @banHandler="addBanClass"
                                @changeMicrophone="changeMicrophoneState"
                                @resetMicrophone="resetMicrophoneState"
                                @playBackgroundMusic="playBackgroundMusicHandler"
                                @stopBackgroundMusic="stopBackgroundMusicHandler"
                            >
                            </Audio>
                        </div>
                    </div>
                </a-drawer>
            </div>
            <!-- 导览部分 -->
            <Guide v-if="item.guide"></Guide>
            <!-- 艺术家名单 -->
            <Mingdan v-if="item.mingdan"></Mingdan>
            <!-- 视频 -->
            <Video v-if="item.hasVideo"
                v-bind:videoUrl="item.videoUrl"
                v-bind:backgroundUrl="item.videoBackgroundImg"
                v-bind:index="index"
                @playBackgroundMusic="playBackgroundMusicHandler"
                @banAllMicroPhone="banAllMicroPhoneHandler">
            </Video>
            <!-- 艺术家简介 -->
            <Artist v-if="item.hasDescription"></Artist>
            <!-- 讯息部分 -->
            <news v-if="item.hasNews"></news>
        </div>
        <div class="top-banner section">
            <div class="posi-img">
                <img class="wall-photo" src="http://www.artgogo.com/online-exhibition/img/1-1.jpg" />
                <p class="title-intro">Thank You For Arting China</p>
            </div>
        </div>
        <!-- 回到顶部 -->
        <BackTop></BackTop>
        <!-- 更换音乐按钮 -->
        <div :class="['change-music', musicDom==null ? '' : 'play']" @click="changeMusic()">
            <img src="http://www.artgogo.com/online-exhibition/img/change.png" alt="">
        </div>
    </div>
</template>
<style>

.ant-drawer-body {
    padding: 0 !important;
}
.backTo{
    position: absolute;
    left: 15px;
    top: 15px;
    width: 40px;
    height: 40px;
    overflow: hidden;
}
.backTo img{
    width: 100%;
    height:100%;

}
.ant-drawer-close {
    font-size: 30px !important;
    color: #fff !important;
    right: 40px!important;
    top: 40px!important;
}
.ant-btn-primary .anticon {
    width: 41px;
    line-height: 2;
    height: 41px;
    opacity: 0;
}
#app {
    width: 100%;
    height: 100%;
    overflow: auto;
}
.section {
    position: relative;
    width: 100%;
    overflow: hidden;
}
.section:after {
    content: '';
    display: block;
    width: 100%;
    height: 0.35rem;
    position: absolute;
    left: 0;
    bottom: 0;
    background: -webkit-linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
    background: -o-linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
    background: -moz-linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
    background: linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
    background: linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
}
.posi-img {
    position: relative;
     width: 100%;
    height: 0;
    padding-bottom: 56%;
    overflow: hidden;
}
.title-intro {
    position: absolute;
    color: #212121;
    font-size: 0.1rem;
    width: 90%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 5px);
}
.wall-photo {
    width: 100%;
}
.microphone {
    /* position: absolute;
    left: 0.1rem;
    bottom: 0.09rem;
    z-index: 1; */
    position: absolute;
    left: 2%;
    bottom: 3%;
    z-index: 111;
    width: 3.5%;
    height: 6%;
}
.icon-microphone{
    width: 100%!important;
    height: 100%!important;
}
.ban:after,
.ban2:after {
    content: '';
    display: block;
    width: 2px;
    height: 82%;
    background: #fff;
    position: absolute;
    left: 48%;
    top: 0;
    transform: rotate(-56deg);
}
.ml {
    margin-left: 6%;
}
.slide-box {
    position: relative;
    margin: 0 0 0%;
    width: 100%;
    height: 0;
    padding-bottom: 54%;
    background-size: cover;
}
.back-img{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.slide-box:after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0%;
    top: 0;
    background-color: rgba(41, 40, 40, 0.7);
}
.mask {
    position: absolute;
    width: 100%;
    height: 0;
    padding-bottom: 66%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 10000;
}
.searchPos2 {
    left: 12%;
    top: 30%;
}
.searchPos3 {
    left: 60%;
    top: 50%;
}
.searchPos4 {
    left: 60%;
    top: 50%;
}
.searchPos5 {
    left: 20%;
    top: 30%;
}
.searchPos6 {
    left: 35%;
    top: 42%;
}
.searchPos7 {
    left: 53%;
    top: 38%;
}
.searchPos8 {
    left: 40%;
    top: 32%;
}
.searchPos9 {
    left: 27%;
    top: 35%;
}
.searchPos10 {
    left: 26%;
    top: 38%;
}
.searchPos10-1 {
    left: 70%;
    top: 43%;
}
.searchPos11 {
    left: 43%;
    top: 32%;
    z-index: 111;
}
.searchPos12 {
    left: 53%;
    top: 34%;
}

.searchPos13 {
    left: 70%;
    top: 34%;
}
.searchPos14 {
    left: 47%;
    top: 34%;
}
.searchPos15 {
    left: 74%;
    top: 39%;
}
.searchPos16 {
    left: 26%;
    top: 37%;
}
.searchPos16-1 {
    left: 67%;
}
.searchPos17 {
    left: 13%;
    top: 55%;
}
.searchPos18 {
    left: 85%;
    top: 50%;
}
.searchPos19 {
    left: 20%;
    top: 15%;
}
.searchPos20 {
    left: 50%;
    top: 30%;
}
.searchPos21 {
    left: 47%;
    top: 35%;
}
.searchPos22 {
    left: 70%;
    top: 55%;
}
.searchPos23 {
    left: 40%;
    top: 23%;
}

/*.imgPos14 {
    top: 33%;
}
.imgPos15 {
    top: 35%;
}*/
.music-box {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.title-words {
    margin: 7% 0 4%;
    font-size: 18px;
}
.music-play-main {
    width: 64%;
    height: 50%;
    float: left;
    margin-left: 18%;
    box-sizing: border-box;
}
@media (min-width: 1920px){ 
    .music-play-main{
        height: 35%;
    }
 }
.music-play-item {
    float: left;
    width: 33%;
    height: 100%;
    position: relative;
}
.music-img-box {
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 100%;
    overflow: hidden;
    margin: 0 auto 0.2rem;
    -webkit-box-shadow: 4px 4px 15px 0px rgba(0,0,0,0.5);
    box-shadow: 4px 4px 15px 0px rgba(0,0,0,0.5);
}
.audio-player {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    margin: 0;
}
.music-playbill {
    width: 100%;
    height: 100%;
}
.play {
    animation: turn 4s linear infinite;
}
@keyframes turn {
    0% {
        -webkit-transform: rotate(0deg);
    }
    25% {
        -webkit-transform: rotate(90deg);
    }
    50% {
        -webkit-transform: rotate(180deg);
    }
    75% {
        -webkit-transform: rotate(270deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}
.music-play-item p {
    width: 110%;
    font-size: 0.1rem;
    transform: scale(0.8);
    margin-left: -4%;
}
.music-play-item button {
    width: 40%;
    background: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 6px;
    font-size: 0.1rem;
    line-height: 0.16rem;
    position: absolute;
    left: 29%;
    bottom: 0;
}
.left {
    position: relative;
    float: left;
    text-align: center;
    width: 100%;
}
.left:after {
    content: '';
    display: block;
    position: absolute;
    background: url('http://www.artgogo.com/online-exhibition/img/down.png') no-repeat;
    left: 39%;
    top: 0;
    width: 0.2rem;
    height: 0.2rem;
    background-size: 0.2rem;
}
.change-music{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum';
    position: fixed;
    right: 100px;
    bottom: 110px;
    z-index: 10;
    width: 40px;
    height: 40px;
    cursor: pointer;
    border-radius: 100%;
}
.change-music img{
    width: 100%;

}
.tuodiantu{
    width: 100% !important;
    height: 100% !important;
}
</style>
<script>
import Mappopover from './Mappopover.vue';
import Carousel from './Carousel.vue';
import Search from './Search.vue';
import BackTop from './Backtop.vue';
import Guide from './Guide.vue';
import Mingdan from './Mingdan.vue';
import Loading from './Loading.vue';
import Video from './Video.vue';
import Artworkalbum from './Artworkalbum.vue';
import Audio from './Audio.vue';
import MusicAudio from './MusicAudio.vue';
import Drawer from './Drawer.vue';
import News from './News.vue';
import Artist from './Artist.vue';

export default {
    components: {
        Mappopover,
        Carousel,
        Search,
        BackTop,
        Guide,
        Mingdan,
        Loading,
        Video,
        Artworkalbum,
        Audio,
        MusicAudio,
        Drawer,
        News,
        Artist,
        
    },
    data() {
        return {
            showFull: false,
            isLoading: true,
            musicDom: null,
            backgroundMusicIndex: -1,
            curBan: '',
            width: '100%',
            preLoadingImg: ['http://www.artgogo.com/online-exhibition/img/1-1.jpg', 'http://www.artgogo.com/online-exhibition/img/1-2.jpg'],
            musicData: [
                {
                    name: 'Fly Away',
                    discri: 'Fly Away by Rexlambo',
                    img: 'http://www.artgogo.com/online-exhibition/amicitia/img/fly-away-album-cover.jpg',
                    music: ['http://www.artgogo.com/online-exhibition/mp4/Rexlambo-fly-away.mp3'],
                    state: false,
                },
                {
                    name: 'Reverie (Piano Version)',
                    discri: 'Reverie (Piano Version) ft. Adarsh PV by Lahar',
                    img: 'http://www.artgogo.com/online-exhibition/amicitia/img/reverie-album-cover.jpg',
                    music: ['http://www.artgogo.com/online-exhibition/mp4/Reverie%28Piano-Version%29-Lahar.mp3'],
                    state: false,
                },
                {
                    name: 'The Age of Wood',
                    discri: 'Original music by Savfk',
                    img: 'http://www.artgogo.com/online-exhibition/amicitia/img/the-age-of-wood-album-cover.jpg',
                    music: ['http://www.artgogo.com/online-exhibition/mp4/Savfk-The-Age-of-Wood(2).wav'],
                    state: false,
                },
            ],
            list: [
                {
                    backgroundImg: '1-1.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    title: "欢迎光临 艺高高的线上展览<br/> Welcome to artgogo's online exhibition",
                    goback:true
                    
                },
                {
                    backgroundImg: '1-2.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    musicPlay: true,
                },
                {
                    backgroundImg: 'course.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    guide:true
                },
                {
                    backgroundImg: 'artist.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    hasDescription:true,
                    changeMeun:true
                },
                {
                    backgroundImg: '1.jpg',
                    mapVisible: false,
                    microphone: true,
                    ban: true,
                    switchBanner: false,
                    mapIcon: true,
                    MaskShow: true,
                    audioCont: ['http://www.artgogo.com/online-exhibition/mp4/20201117_173407.m4a'],
                    lyric: [
                        {
                            time: '01',
                            words: '欢迎各位来到位于上海程家桥路299号',
                        },
                        {
                            time: '05',
                            words: '伯爵山庄里的 ',
                        },
                        {
                            time: '07',
                            words: '我们崭新的艺术空间 ',
                        },
                        {
                            time: '09',
                            words: '艺高高的“巢”',
                        },
                        {
                            time: '011',
                            words: '开幕首展就是Peter Riezebos的《AMICITIA》',
                        },
                        {
                            time: '15',
                            words: '新书发布的个展',
                        },
                        {
                            time: '17',
                            words: 'a very warm welcome to you ',
                        }
                    ],
                },
                {
                    backgroundImg: '2.jpg',
                    mapVisible: false,
                    microphone: false,
                    switchBanner: false,
                    ban: true,
                    className:'searchPos2',
                    mapIcon: true,
                    MaskShow: true,
                    hasHandler: true,
                    single: {
                        "num": 28,
                        "artist":"Peter Riezebos",
                        "title": "喜狮 No.3",
                        "caizhi": "Acrylic, Oil & Spray Paint on Linen 亚麻布面丙烯油彩及喷漆",
                        "words": "Chinese Lion",
                        "chinese":"中国狮子",
                        "size": "110*160",
                        "year": 2018,
                        "href": "http://www.artgogo.com/yishupin/2018-4-28_152490105257.shtml",
                        "img": "http://www.artgogo.com/images/2018/4/28/1524900671dmtoyhs70_a.jpg",                      
                    },
                },
                {
                    backgroundImg: '3.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className:'searchPos3',
                    visible: false,
                    carousel: [
                        {
                            "num": 28,
                            "artist":"Peter Riezebos",
                            "title": "Excitement",
                            "caizhi": "布面综合材料",
                            "words": "Showcasing the emotional state of excitement",
                            "chinese":"呈现了一种兴奋高亢的情绪状态",
                            "size": "73*93",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-3-17_1458187909930.shtml",
                            "img": "http://www.artgogo.com/images/2016/3/17/1458187659rgyis4564_a.jpg"
                        },
                        {
                            "num": 28,
                            "artist":"Peter Riezebos",
                            "title": "Happiness Series 2016 - 13",
                            "caizhi": "布面综合材料",
                            "words": "A series of happiness",
                            "chinese":"快乐系列表达快乐的同时也在传递快乐",
                            "size": "73*93",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-5-13_1463109194759.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2016/6/27/20166271467014526282_371_a.jpg"
                        },
                        {
                            "num": 71,
                            "artist":"Peter Riezebos",
                            "title": "GO DUTCH",
                            "caizhi": "纸面邮票",
                            "words": "Official national post stamps based on my paintings of the Go Dutch series",
                            "chinese":"以“Go Dutch”系列作品为画面的荷兰国家官方邮票",
                            "size": "56*41",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2018-4-29_1524990417670.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2018/5/3/2018531525336771208_376_a.jpg"
                        },
                         {
                            "num": 50,
                            "artist":"Peter Riezebos",
                            "title": "本命年专属瓷盘ArtgogoxPeter Riezebos-猴",
                            "caizhi": "骨瓷 Fine Bone China",
                            "words": false,
                            "chinese":"",
                            "size": "28*28",
                            "year": '',
                            "href": "http://www.artgogo.com/yishupin/2016-3-31_1459411679235.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/4/1/2017411491033843372_371_a.jpg"
                        },
                    ],
                },
                {
                    backgroundImg: '4.jpg',
                    mapVisible: false,
                    microphone: false,
                    ban: true,
                    switchBanner: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos4',
                    hasHandler: true,
                    single: 
                        {
                            "num": 69,
                            "artist":"Peter Riezebos",
                            "title": "龙 No.1",
                            "caizhi": "Acrylic, Oil & Spray Paint on Linen 亚麻布面丙烯油彩及喷漆",
                            "words": "Chinese Dragon",
                            "chinese":"中国龙",
                            "size": "300*200",
                            "year": 2018,
                            "href": "http://www.artgogo.com/yishupin/2018-4-28_1524901024979.shtml",
                            "img": "http://www.artgogo.com/images/2018/4/28/1524900655rmaogyps3_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '5.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    // Guide: true,
                    hasHandler: true,
                    className:'searchPos5',
                    single:
                         {
                            "num": 50,
                            "artist":"Peter Riezebos",
                            "title": "What You Owns You 你拥有的一切左右了你",
                            "caizhi": "布面综合材料",
                            "words": "The focus on material things makes us slaves towards a system that was never part of the physical reality. ",
                            "chinese":"对物质的过分关注和追逐使我们渐渐臣服于一个非物质的虚拟系统",
                            "size": "200*200",
                            "year": 2017,
                            "href": "http://www.artgogo.com/yishupin/2017-4-6_1491450373783.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/5/22/20175221495436752341_376_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '6.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos6',
                    hasHandler: true,
                    single:
                         {
                            "num": 36,
                            "artist":"Peter Riezebos",
                            "title": "Infinite Wonder 无限的好奇",
                            "caizhi": "亚布面综合材料",
                            "words": null,
                            "chinese":"",
                            "size": "300×200cm",
                            "year": 2017,
                            "href": "http://www.artgogo.com/yishupin/2016-5-11_1462946553243.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/4/12/20174121491984657747_376_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '7.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    hasHandler: true,
                    className:'searchPos7',
                    single:
                        {
                            "num": 15,
                            "artist":"Peter Riezebos",
                            "title": "Radical Doubt \n高度怀疑",
                            "caizhi": "丙烯",
                            "words": "Radical doubt is a fundamental part of critical thinking",
                            "chinese":"高度怀疑是批判性思考的一个基础部分",
                            "size": "200*200",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-1-15_145283031277.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/5/22/20175221495435314597_376_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '8.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos8',
                    hasHandler: true,
                    single:
                        {
                            "num": 67,
                            "artist":"Peter Riezebos",
                            "title": "喜狮 No.2",
                            "caizhi": "Acrylic, Oil & Spray Paint on Linen 亚麻布面丙烯油彩及喷漆",
                            "words": "Chinese Lion",
                            "chinese":"中国狮子",
                            "size": "200*200",
                            "year": 2018,
                            "href": "http://www.artgogo.com/yishupin/2018-4-28_1524901046431.shtml",
                            "img": "http://www.artgogo.com/images/2018/4/28/1524900668demlphc62_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '9.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className:'searchPos9',
                    visible: false,
                    carousel:[
                        {
                            "num": 6,
                            "artist":"Peter Riezebos",
                            "title": "艺术彩绘钢琴",
                            "caizhi": "综合材料艺术衍生品 Mixed Media Art Derivative Product",
                            "words": "Painted piano. By painting the piano the seeming emotionless object came to life",
                            "chinese":"透过彩绘，这个看似没有情感的物体变得如拥有了生命",
                            "size": "151x126x61",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-5-27_1464325620328.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2016/5/27/20165271464326078227_259_a.png"
                        },
                        {
                            "num": 17,
                            "artist":"Peter Riezebos",
                            "title": "Empowerment 赋予权力",
                            "caizhi": "布面综合材料",
                            "words": "Empowerment makes us grow as individuals",
                            "chinese":"赋予权力使我们能真正作为个体成长",
                            "size": "80*100",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-3-17_1458187885764.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/5/19/20175191495187813862_376_a.jpg"
                        },
                    ]
                },
                {
                    backgroundImg: '10.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    // hasVideo: true,
                    className:'searchPos10',
                    visible: false,
                    carousel:[
                        {
                            "num": 24,
                            "artist":"Peter Riezebos",
                            "title": "Happiness Series 2016 - 7",
                            "caizhi": "布面综合材料 Mixed Media on Canvas",
                            "words": "A series of happiness",
                            "chinese":"快乐系列表达快乐的同时也在传递快乐",
                            "size": "50*100",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-5-13_1463108608126.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2016/5/20/20165201463714709265_259_a.jpg"
                        },
                        {
                            "num": 25,
                            "artist":"Peter Riezebos",
                            "title": "Happiness Series 2016 - 8",
                            "caizhi": "布面综合材料 Mixed Media on Canvas",
                            "words": "A series of happiness",
                            "chinese":"快乐系列表达快乐的同时也在传递快乐",
                            "size": "50*100",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-5-13_1463108825226.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2016/5/20/20165201463714666055_259_a.jpg"
                        },
                        {
                            "num": 22,
                            "artist":"Peter Riezebos",
                            "title": "Happiness Series 2016 - 5",
                            "caizhi": "布面综合材料 Mixed Media on Canvas",
                            "words": "A series of happiness",
                            "chinese":"快乐系列表达快乐的同时也在传递快乐",
                            "size": "50*100",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-5-13_1463108477600.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2016/5/20/20165201463714743083_259_a.jpg"
                        },
                    ]
                },
                {
                    backgroundImg: '11.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos11',
                    hasHandler: true,
                    single: 
                        {
                            "num": 4,
                            "artist":"Peter Riezebos",
                            "title": "Black & White Color Complex  黑白情结",
                            "caizhi": "丙烯 Acrylic",
                            "words":"Perception - in art and as a psychological and philosophical construct - has many layers. From the surface structures to many underlying elements that can be discovered. Such is life. Sometimes it presents obstacles on face value which also presents opportunities that urge a deeper thinking and facilitate an understanding of humanity and nature. Art can helps us overcome many obstacles in life.",
                            "chinese":"感知：在艺术中以及作为一种心理学和哲学里的建构，感知都具有许多层次。可以从表面结构一直深入到底层发现很多元素。这就是生活。有时，它在表面上布满荆棘，却也提供了促使人们进行更深入的思考并对人性与大自然更深入理解的机会。艺术可以帮助我们克服生活中的许多障碍",
                            "size": "200*200",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-1-15_1452830309386.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/5/19/20175191495187623167_376_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '12.jpg',
                    mapVisible: false,
                    microphone: true,
                    mapIcon: true,
                    hasHandler: true,
                    className:'searchPos12',
                    ban: true,
                    audioCont: ['http://www.artgogo.com/online-exhibition/mp4/20201117_173436.m4a'],
                    lyric: [
                        {
                            time: '01',
                            words: '我收到了这幅画',
                        },
                        {
                            time: '02',
                            words: '而且peter说的是献给我的好朋友CT',
                        },
                        {
                            time: '06',
                            words: 'the best and C ',
                        },
                        {
                            time: '08',
                            words: '其实他只看过我两场这个艺术拍卖的主持',
                        },
                        {
                            time: '013',
                            words: '额 他这样夸我不知道哪听来的',
                        },
                        {
                            time: '15',
                            words: '但是很谢谢',
                        },
                        {
                            time: '17',
                            words: '而且刚好准确的集中在我的心里',
                        },
                        {
                            time: '20',
                            words: '成为我这一生一直会留在身边的作品',
                        },
                    ],
                    single:
                        {
                            "num": 7,
                            "artist":"Peter Riezebos",
                            "title": "Best MC",
                            "caizhi": "布面综合材料 Mixed Media on Canvas",
                            "words": "Fun painting as a gift to my dear friend CT CAO who is one of the best MCs in the world.",
                            "chinese":"送给我的挚友曹启泰的一件作品，他就是世界上最好的主持人之一",
                            "size": "70*70",
                            "year": null,
                            "href": "http://www.artgogo.com/yishupin/2017-4-20_149267922741.shtml",
                            "img": "http://www.artgogo.com/images/2017/4/20/1492679198atolphs02_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '13.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className:'searchPos13',
                    visible: false,
                    carousel:[
                        {
                            "num": 66,
                            "artist":"Peter Riezebos",
                            "title": "喜狮 No.1",
                            "caizhi": "Acrylic, Oil & Spray Paint on Linen 亚麻布面丙烯油彩及喷漆",
                            "words": "Chinese Lion",
                            "chinese":"中国狮子",
                            "size": "200*200",
                            "year": 2018,
                            "href": "http://www.artgogo.com/yishupin/2018-4-28_1524901039443.shtml",
                            "img": "http://www.artgogo.com/images/2018/4/28/1524900665drgphcs29_a.jpg"
                        },
                        {
                            "num": 66,
                            "artist":"Peter Riezebos",
                            "title": "Chinese Artifacts",
                            "caizhi": "艺高高的艺术家作品集 artgogo Artist Art Collection",
                            "words": "",
                            "chinese":"",
                            "size": "27*27",
                            "year": '',
                            "href": "http://www.artgogo.com/yishupin/2017-5-4_1493896722336.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/5/4/2017541493896801720_376_a.jpg"
                        },
                        {
                            "num": 66,
                            "artist":"Peter Riezebos",
                            "title": "Existential Lines 存在主义·线条",
                            "caizhi": "艺高高的艺术家作品集 artgogo Artist Art Collection",
                            "words": "",
                            "chinese":"",
                            "size": "",
                            "year": '',
                            "href": "http://www.artgogo.com/yishupin/2020-9-1_159897116650.shtml",
                            "img": "http://www.artgogo.com/images/artwork/2020-9/1598971137demaoyc00.jpg"
                        },
                        {
                            "num": 66,
                            "artist":"Peter Riezebos",
                            "title": "Butorflēoge",
                            "caizhi": "艺高高的艺术家作品集 artgogo Artist Art Collection",
                            "words": "",
                            "chinese":"",
                            "size": "",
                            "year": '',
                            "href": "http://www.artgogo.com/yishupin/2018-5-7_1525684863938.shtml",
                            "img": "http://www.artgogo.com/images/2018/5/7/1525684728drtolh124_a.jpg"
                        },
                    ]

                },
                 {
                    backgroundImg: 'floors.jpg',
                    mapVisible: false,
                    microphone: false
                },
                {
                    backgroundImg: '14.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    hasHandler: true,
                    className:'searchPos14',
                    single:
                        {
                            "num": 19,
                            "artist":"Peter Riezebos",
                            "title": "Random .... MoFo",
                            "caizhi": "木板综合材料 Mixed Media on Wood",
                            "words":"This door was found at the garbage on the street. It had been functioning as protection for a family home (given the still visible Chinese symbols on it). After serving the family it was disregarded. By making it an art work it was resurrected. ",                            "chinese":"",
                            "chinese":"这个门是在街边垃圾堆里捡到的。它曾是一个家庭的保护者，一道特别的防线，它的身上还贴着显而易见的中国元素，而现在它却被如此丢弃了。愿能把它变成一件艺术作品，赋予它新生。",
                            "size": "202*81",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2017-12-8_1512726280220.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2018/4/24/20184241524561106172_376_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '15.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    hasHandler: true,
                    className:'searchPos15',
                    single:
                        {
                            "num": 21,
                            "artist":"Peter Riezebos",
                            "title": "Happiness Series 2016 - 2",
                            "caizhi": "布面综合材料 Mixed Media on Canvas",
                            "words": "A series of happiness",
                            "chinese":"快乐系列表达快乐的同时也在传递快乐",
                            "size": "100*130",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-5-13_1463108156200.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2016/5/20/20165201463714808468_259_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '16.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    visible: false,
                    className:'searchPos16',
                    carousel: [
                        {
                            "num": 2,
                            "artist":"Peter Riezebos",
                            "title": "Playful 2015 嬉闹 2015",
                            "caizhi": "布面综合材料 Mixed Media on Canvas",
                            "words": "Live art painting. Made during a 2 hour live art session in Global Harbour Shanghai ",
                            "chinese":"一件现场绘画的作品。在上海环球港的一个活动里用时2小时完成",
                            "size": "100*100",
                            "year": 2015,
                            "href": "http://www.artgogo.com/yishupin/2015-10-14_1444818405962.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2015/10/14/201510141444818394229_358_a.jpg"
                        },
                        {
                            "num": 34,
                            "artist":"Peter Riezebos",
                            "title": "Food Love Series 4",
                            "caizhi": "亚布面综合材料 Mixed Media on Linen",
                            "words": "Made for More Than One (MTO) restaurant",
                            "chinese":"",
                            "size": "100×100cm",
                            "year": 2014,
                            "href": "http://www.artgogo.com/yishupin/2016-5-11_1462946548560.shtml",
                            "img": "http://www.artgogo.com/images/2016/5/11/1462945581emagyphi6_a.jpg"
                        },
                    ]
                },
                {
                    backgroundImg: '17.jpg',
                    mapVisible: false,
                    microphone: false,
                    hasHandler: true,
                    mapIcon: true,
                    className:'searchPos17',
                    single:
                        {
                            "num": 48,
                            "artist":"Peter Riezebos",
                            "title": "One Way Ticker To Heaven 通往天堂的单程票",
                            "caizhi": "布面综合材料 Mixed Media on Canvas",
                            "words": "Portrait of Lindy",
                            "chinese":"Lindy的肖像",
                            "size": "200*200",
                            "year": 2017,
                            "href": "http://www.artgogo.com/yishupin/2017-4-6_1491449879687.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/5/22/20175221495436267126_376_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '18.jpg',
                    mapVisible: false,
                    microphone: true,
                    mapIcon: true,
                    MaskShow: true,
                    visible: false,
                    ban: true,
                    audioCont: ['http://www.artgogo.com/online-exhibition/mp4/20201117_173516.m4a'],
                    lyric: [
                        {
                            time: '01',
                            words: '哈 这一本AMICITIA其实绝无仅有',
                        },
                        {
                            time: '04',
                            words: '它记录的是2020年7月24号',
                        },
                        {
                            time: '07',
                            words: 'peter的AMICITIA的个展开幕以及',
                        },
                        {
                            time: '10',
                            words: '新书媒体发布会上所有到场嘉宾以及',
                        },
                        {
                            time: '14',
                            words: '很多很多艺术家们共同的亲笔签名',
                        },
                        {
                            time: '17',
                            words: '我在这提醒你下一页当中有视频',
                        },
                        {
                            time: '20',
                            words: '记得点击播放',
                        },
                        {
                            time: '21',
                            words: '很好看哦',
                        },
                    ],
                    className:'searchPos18',
                     carousel: [
                        {
                            "num": 48,
                            "artist":"Peter Riezebos",
                            "title": "AMICITIA",
                            "caizhi": "艺术书 Art Book",
                            "words": "",
                            "chinese":"",
                            "size": "",
                            "year": '',
                            "href": "http://www.artgogo.com/yishupin/2020-9-1_1598970319284.shtml",
                            "img": "http://www.artgogo.com/images/2020/9/2/2020921599029837101_394.jpg"
                        },
                        {
                            "num": 48,
                            "artist":"Peter Riezebos",
                            "title": "AMICITIA",
                            "caizhi": "艺术书 Art Book",
                            "words": "",
                            "chinese":"",
                            "size": "",
                            "year": '',
                            "href": "http://www.artgogo.com/yishupin/2020-9-1_1598970319284.shtml",
                            "img": "http://www.artgogo.com/online-exhibition/amicitia/original-img/wechat.jpg"
                        },
                        {
                            "num": 48,
                            "artist":"Peter Riezebos",
                            "title": "AMICITIA",
                            "caizhi": "艺术书 Art Book",
                            "words": "",
                            "chinese":"",
                            "size": "",
                            "year": '',
                            "href": "http://www.artgogo.com/yishupin/2020-9-1_1598970319284.shtml",
                            "img": "http://www.artgogo.com/online-exhibition/amicitia/original-img/WechatIMG306.png"
                        }
                     ]
                },
                {
                    backgroundImg: 'video-background.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: true,
                    hasVideo: true,
                    videoBackgroundImg:'http://www.artgogo.com/online-exhibition/amicitia/original-img/video-background.jpg',
                    videoUrl:'http://www.artgogo.com/online-exhibition/mp4/amicitia.mp4',
                },
                {
                    backgroundImg: '19.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    
                },
                {
                    backgroundImg: '20.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    hasHandler: true,
                    className:'searchPos20',
                    single:
                        {
                            "num": 73,
                            "artist":"Peter Riezebos",
                            "title": "Longevity, Wealth & Happiness 福禄寿",
                            "caizhi": "Acrylic, Oil & Spray Paint on Linen 亚麻布面丙烯油彩及喷漆",
                            "words": "My interpretation of the three statues from Chinese tradition",
                            "chinese":"这是我对于中国传统神仙人物的解读",
                            "size": "300*200",
                            "year": 2017,
                            "href": "http://www.artgogo.com/yishupin/2017-4-6_1491449848122.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/5/22/20175221495436200700_376_a.jpg"
                        },
                    
                },

                {
                    backgroundImg: '21.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    hasHandler: true,
                    className:'searchPos21',
                    single: 
                        {
                            "num": 47,
                            "artist":"Peter Riezebos",
                            "title": "Funky Twombly 手舞足蹈的托姆布雷",
                            "caizhi": "布面综合材料 Mixed Media on Canvas",
                            "words": null,
                            "chinese":"",
                            "size": "200*200",
                            "year": 2017,
                            "href": "http://www.artgogo.com/yishupin/2017-4-6_149144790870.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2017/5/22/20175221495435888243_376_a.jpg"
                        },
                        
                    
                },
                {
                    backgroundImg: '22.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    hasHandler: true,
                    className:'searchPos22',
                    single:
                        {
                             "num": 33,
                            "artist":"Peter Riezebos",
                            "title": "Food Love Series 3",
                            "caizhi": "布面综合材料 Mixed Media on Canvas",
                            "words": "Made for More Than One (MTO) restaurant",
                            "chinese":"为MTO餐厅创作的作品",
                            "size": "100×100cm",
                            "year": 2014,
                            "href": "http://www.artgogo.com/yishupin/2016-5-11_1462946544324.shtml",
                            "img": "http://www.artgogo.com/images/2016/5/11/1462945579rmagpc626_a.jpg"
                        },
                    
                },
                {
                    backgroundImg: '23.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: false,
                    hasHandler: true,
                    className:'searchPos23',
                    single:
                        {
                            "num": 5,
                            "artist":"Peter Riezebos",
                            "title": "Facing the Tyranny of the Majority 直面多数建议",
                            "caizhi": "综合材料 Mixed Media",
                            "words": "Live art painting made for ROI festival in Ritz Carlton Shanghai. The painting depicts a person with interchangeable heads for different types of emotions ",
                            "chinese":"在上海商场举办的金投赏国际创意峰会中完成的现场创作。这件作品呈现了一个拥有多个可替换头脑的人，可以自如切换于不同的情绪情感之间",
                            "size": "200*200",
                            "year": 2016,
                            "href": "http://www.artgogo.com/yishupin/2016-10-20_1476936084207.shtml",
                            "img": "http://www.artgogo.com/yishupin/images/2016/11/3/20161131478163948646_376_a.jpg"
                        }
                    
                },
                {
                    microphone: true,
                    backgroundImg: 'letter.jpg',
                    ban: true,
                    audioCont: ['http://www.artgogo.com/online-exhibition/mp4/20201117_173552.m4a'],
                    lyric: [
                        {
                            time: '01',
                            words: '在这里我要特别谢谢Peter',
                        },
                        {
                            time: '03',
                            words: 'Peter Riezebos',
                        },
                        {
                            time: '05',
                            words: '他成功的对我们展示里作为一个',
                        },
                        {
                            time: '08',
                            words: '作为艺术家积极向上、努力企划',
                        },
                        {
                            time: '11',
                            words: '而且不达目的绝不休止',
                        },
                        {
                            time: '13',
                            words: '契而不舍的态度',
                        },
                        {
                            time: '16',
                            words: '也谢谢所有的朋友成为本场展览的',
                        },
                        {
                            time: '18',
                            words: '证 线上见证人',
                        },
                        {
                            time: '20',
                            words: '你见证了这个艺术行为、艺术作品',
                        },
                        {
                            time: '24',
                            words: '以及这场艺术展永不落幕的线上展览',
                        },
                        {
                            time: '29',
                            words: '谢谢您的见证 谢谢您',
                        },
                    ],
                },
                {
                    backgroundImg: '24.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    hasNews: true,
                },
            ],
        };
    },
    mounted() {
        let that = this;
        this.$nextTick(function() {
            that.loadImages(that.preLoadingImg);
        });
    },
    methods: {
        back(){
            window.history.go(-1);//返回上一层
        },
        loadImages(images) {
            let promiseAll = [],
                imgs = [],
                total = images.length;
            for (let i = 0; i < total; i++) {
                promiseAll[i] = new Promise((resolve, reject) => {
                    imgs[i] = new Image();
                    imgs[i].src = images[i];
                    imgs[i].onload = () => {
                        resolve(imgs[i]);
                    };
                    imgs[i].onerror = () => {};
                });
            }
            Promise.all(promiseAll).then((img) => {
                this.isLoading = false;
            });
        },
        // 去除轮播遮罩
        toshow(msg) {
            this.list[msg].MaskShow = false;
        },
        //改变麦克风状态
        changeMicrophoneState(idx, bans) {
            if (bans) {
                this.list[10].ban2 = !this.list[10].ban2;
                // 手动关闭当前语音后播放背景音乐
                if (this.list[10].ban2 == true && this.musicDom != null) {
                    this.musicDom.play();
                }
            } else {
                this.list[idx].ban = !this.list[idx].ban;
                // 手动关闭当前语音后播放背景音乐
                if (this.list[idx].ban == true && this.musicDom != null) {
                    this.musicDom.play();
                }
            }
        },
        //让所有的麦克风都变成斜杠状态, 保留当前点击的麦克风状态
        addBanClass(idx, bans) {
            //记录当前被点击的麦克风的状态
            if (bans) {
                this.curBan = this.list[10].ban2;
            } else {
                this.curBan = this.list[idx].ban;
            }

            let that = this;

            for (let i = 0; i < that.list.length; i++) {
                if (that.list[i].ban != undefined) {
                    that.list[i].ban = true;
                    that.list[10].ban2 = true;
                }
            }
            setTimeout(function() {
                if (bans) {
                    that.list[10].ban2 = that.curBan;
                } else {
                    that.list[idx].ban = that.curBan;
                }
            }, 100);
        },
        //让所有的麦克风都变成斜杠状态
        banAllMicroPhoneHandler() {
            let that = this;
            this.list[10].ban2 = true;
            for (let i = 0; i < that.list.length; i++) {
                if (that.list[i].ban != undefined) {
                    that.list[i].ban = true;
                }
            }
        },
        // 监听语音播放结束
        resetMicrophoneState(idx) {
            this.list[idx].ban = true;
            this.list[10].ban2 = true;
        },

        //记录背景音乐、添加旋转动画
        markBackgroundMusicHandler(music, idx) {
            this.musicDom = music;
            let musicPlayDom = document.getElementsByClassName('music-playbill');
            for (let i = 0; i < musicPlayDom.length; i++) {
                if (i != idx) {
                    document.getElementsByClassName('music-playbill')[i].classList.remove('play');
                } else {
                    document.getElementById(`musicPlay${idx}`).classList.add('play');
                }
            }
        },
        //清除背景音乐以及旋转动画
        clearnBackgroundMusicHandler(idx) {
            this.musicDom = null;
            document.getElementById(`musicPlay${idx}`).classList.remove('play');
        },
        // 背景音乐打断后继续播放
        playBackgroundMusicHandler() {
            if (this.musicDom != null) {
                this.musicDom.play();
            }
        },
        showDrawer(idx) {
            this.list[idx].visible = true;
        },
        onClose(idx) {
            this.list[idx].visible = false;
            this.list[idx].visibleOne = false;
            this.list[idx].visibleTwo = false;
        },
        showDrawerOne(idx) {
            this.list[idx].visibleOne = true;
        },
        showDrawerTwo(idx) {
            this.list[idx].visibleTwo = true;
        },
        stopBackgroundMusicHandler(){
            if (this.musicDom != null) {
                this.musicDom.pause();
               // console.log('stop musicDom')
            }
        },
         //记录点击的背景音乐index
        markMusicIndexHandler(idx){
            this.backgroundMusicIndex = idx
            for(let i = 0; i < this.musicData.length; i++){
                if(i == idx){
                    this.musicData[idx].state = true
                }else{
                    this.musicData[i].state = false
                }
            }            
        },
        // 更换下一首音乐
        changeMusic(){
            let that = this
            let music = document.getElementById('musicPlayBox')
            let backgroundMusic = music.getElementsByTagName('audio');
            //清除背景音乐以及旋转动画,-1代表初始值
            if(this.backgroundMusicIndex!=-1){
                 this.clearnBackgroundMusicHandler(this.backgroundMusicIndex);
            }
            for(let i = 0; i < backgroundMusic.length; i++){
                backgroundMusic[i].pause()
            }
            that.backgroundMusicIndex++
            if(that.backgroundMusicIndex >= 3){
                //到第三首停止音乐
                that.stopBackgroundMusicHandler()
                that.backgroundMusicIndex = -1
                
            }else{

                backgroundMusic[that.backgroundMusicIndex].play();
            }
            backgroundMusic[that.backgroundMusicIndex].play()
            //记录背景音乐、添加旋转动画
            that.markBackgroundMusicHandler(backgroundMusic[that.backgroundMusicIndex],that.backgroundMusicIndex)
            this.musicDom = backgroundMusic[that.backgroundMusicIndex]
            
        }
    },
};
</script>
